import {defineNuxtPlugin, useNuxtApp} from '#app'
import axios from 'axios'
import {useProductStore} from "~/plugins/store/product";
import type {ProductStatuses} from "~/types/Product";
import {useAuthStore} from "~/plugins/store/auth";
import auth from "~/middleware/auth";

export default defineNuxtPlugin((nuxtApp) => {
    axios.interceptors.response.use(
        async response => {

            let tmpProductStatuses = response.headers['x-site-product-statuses'];
            if (tmpProductStatuses) {
               tmpProductStatuses = JSON.parse(tmpProductStatuses) as ProductStatuses;
               const productStore = useProductStore();
               if (productStore.productStatuses.updated_at !== tmpProductStatuses.updated_at) {
                   productStore.productStatuses = tmpProductStatuses;
               }
            }
            return response;
        },
        async error => {
            if (error.response && error.response.data && error.response.data.error) {
                const {code, message, pretty_message} = error.response.data.error;
                if (code === 503) {
                    navigateTo('/maintenance');
                } else if (error.response && error.response.status === 401 || error.response.status === 403) {
                    const authStore = useAuthStore();
                    await authStore.logout();
                    authStore.user = null;
                    alert('You have been logged out due to inactivity.');
                    navigateTo('/authenticate');
                } else if (error.response && error.response.status === 422 && message) {
                    const { $toast } = useNuxtApp();
                    const parsedMessage = JSON.parse(message);

                    Object.keys(parsedMessage).forEach(field => {
                        if (parsedMessage.hasOwnProperty(field)) {
                            $toast.error(parsedMessage[field][0]);
                        }
                    });
                }
            }
            return Promise.reject(error);
        }
    )

})